enum ContactType {
	HOME = '6',
	MOBILE = '10',
	BUSINESS = '7'
}

const contacts = [
	ContactType.HOME,
	ContactType.MOBILE,
	ContactType.BUSINESS
];

const description = (ct: ContactType) => {
	switch (ct) {
		case ContactType.HOME:
			return 'bookingDetails.label.home';
		case ContactType.MOBILE:
			return 'bookingDetails.label.mobile';
		case ContactType.BUSINESS:
			return 'bookingDetails.label.business';
		default:
			return '';
	}
}

export const ContactTypeEnum = {
	allValues: contacts,
	description: description
};
